import { render, staticRenderFns } from "./jieguo.vue?vue&type=template&id=45f3759e&scoped=true"
import script from "./jieguo.vue?vue&type=script&lang=js"
export * from "./jieguo.vue?vue&type=script&lang=js"
import style0 from "./jieguo.vue?vue&type=style&index=0&id=45f3759e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f3759e",
  null
  
)

export default component.exports